export enum QueryStringParameter {
    Name = "name",
    Price = "price"
}

export enum SortQueryStringParameter {
    Asc = "asc",
    Desc = "desc"
}